
<input
type="file" multiple
id="fileInput"
(change)="selectFile($event)"  #fileUpload
name="fileInput"
/>

<ion-fab-button (click)="fileUpload.click()">
  <ion-icon name="folder-open-outline"></ion-icon>
</ion-fab-button>